// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2undY","insightsList":"newBusinessInsightsMenu_insightsList__1nw6q","active":"newBusinessInsightsMenu_active__3hHzk"};